var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -2)",
    fill: "#2D2D44"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.804 10.979) rotate(-10) translate(-11.408 -8.7551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m20.591 0.092327c1.1727 0 2.1224 0.9498 2.1224 2.1224v10.612c0 1.1721-0.9498 2.1224-2.1224 2.1224h-1.0384v-1.0612h1.0389c0.5598 0 1.0182-0.43298 1.0586-0.98216l0.0026531-0.079592v-10.612c0-0.5858-0.4749-1.0612-1.0612-1.0612h-15.918c-0.55927 0-1.0177 0.43351-1.058 0.98216l-0.0031837 0.079592v1.0289h-1.0612v-1.0294c0-1.1716 0.95033-2.1224 2.1224-2.1224h15.918l-5.306e-4 5.3061e-4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.087385,
    y: 0.053538,
    width: 23.385,
    height: 17.231,
    rx: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(4.7397 12.939) rotate(-45) translate(-4.7397 -12.939)",
    points: "-0.18338 12.323 9.6628 12.323 9.6628 13.554 -0.18338 13.554",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    transform: "translate(18.894 12.939) scale(-1 1) rotate(-45) translate(-18.894 -12.939)",
    points: "13.971 12.324 23.817 12.324 23.817 13.555 13.971 13.555",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.01 0.66892c1.36 0 2.4615 1.1015 2.4615 2.4615v12.308c0 1.36-1.1015 2.4615-2.4615 2.4615h-18.462c-1.36 0-2.4615-1.1015-2.4615-2.4615v-12.308c0-1.36 1.1015-2.4615 2.4615-2.4615h18.462zm0 1.2308h-18.462c-0.68 0-1.2308 0.55077-1.2308 1.2308v12.308c0 0.68 0.55077 1.2308 1.2308 1.2308h18.462c0.68 0 1.2308-0.55077 1.2308-1.2308v-12.308c0-0.68-0.55077-1.2308-1.2308-1.2308z",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 7.472,
    y: 3.1305,
    width: 8.6154,
    height: 1.2308,
    rx: 0.61538,
    fill: "#E05C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.2646 1.4609 0.071385 0.078154 9.5735 9.5735c0.45538 0.45538 1.1785 0.47877 1.6622 0.071385l0.078154-0.071385 9.5735-9.5735 0.052923-0.059077v1.7458l-8.7563 8.7569c-0.96123 0.96123-2.5194 0.96123-3.4806 0l-8.8092-8.8098-0.0018462-1.7563 0.036308 0.044308z",
    fill: "#2D2D44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.472,
    y: 5.592,
    width: 4.9231,
    height: 1.2308,
    rx: 0.61538,
    fill: "#E05C55"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.73039b3a038048c01bd5ef3cb186d766.svg";
export { ForwardRef as ReactComponent };